// extracted by mini-css-extract-plugin
export default {"wrapper":"Game_wrapper__gBPYl","iframe":"Game_iframe__6ZriW"};